export default __webpack_public_path__ + "static/media/background+pict@2x.134f9511.png";